module.exports = __webpack_public_path__ + "img/semiconductor_advantage_bg_img01.de1cb856.png";